import React from "react";
import BaseButton from "./BaseButton";
import { DeleteOutlined } from '@ant-design/icons';
// import './BaseStyle.css'

const BaseDelete = (props) =>
  <BaseButton className="delete-button" { ...props } >{ props.text ? props.text : "Delete" } <DeleteOutlined /></BaseButton>

export default BaseDelete;
